import styled from '@emotion/styled';
import Headline3 from './Typography/Heading/Headline3';
import Button from './Button';
import breakpoints from './Theme/breakpoints';

export { ListItem as StyledListItem } from './List';

export const JobsLandingContainer = styled.div`
  && {
    display: grid;
    grid-gap: 16px;
    padding: 16px;
    grid-template-columns: repeat(4,minmax(0,1fr));

    @media (min-width: ${breakpoints.sm}px) {
      grid-template-columns: repeat(8,minmax(0,1fr));
    }

    @media (min-width: ${breakpoints.lg}px) {
      grid-template-columns: repeat(12,minmax(0,1fr));
    }
  }
`;

export const JobsLandingTitle = styled.div`
  && {
    width: auto;
    grid-column-end: span 4;

    @media (min-width: ${breakpoints.sm}px) {
      width: auto;
      grid-column-end: span 8;
    }

    @media (min-width: ${breakpoints.lg}px) {
      grid-column-start: 2;
      grid-column-end: 12;
    }
  }
`;

export const JobsLandingCategories = styled.div`
  && {
    width: auto;
    grid-column-end: span 4;

    @media (min-width: ${breakpoints.sm}px) {
      grid-column-end: span 8;
    }

    @media (min-width: ${breakpoints.lg}px) {
      grid-column-start: 2;
      grid-column-end: 9;
    }
  }
`;

export const JobsLandingSidebar = styled.div`
  && {
    grid-column-end: span 4;

    @media (min-width: ${breakpoints.sm}px) {
      grid-column-end: span 8;
    }

    @media (min-width: ${breakpoints.md}px) {
      width: auto;
      grid-column-end: span 8;
    }

    @media (min-width: ${breakpoints.lg}px) {
      grid-column-end: span 3;
    }
  }
`;

export const JobsLandingAds = styled.div`
  && {
    width: auto;
    grid-column-end: span 4;
    align-self: center;

    @media (min-width: ${breakpoints.lg}px) {
      grid-column-end: span 3;
    }
  }
`;

export const StyledButton = styled(Button)`
  && {
    margin: 16px auto 32px;
    font-size: 16px;
    display: block;
    white-space: nowrap;
  }
`;

export const Title = styled(Headline3)`
  && {
    font-size: 2rem;
    line-height: 2.5rem;
    min-height: 240px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    @media (min-width: ${breakpoints.sm}px) {
      margin: 32px 16px 16px;
      font-size: 2rem;
      line-height: inherit;
      min-height: auto;
      display: block;
    }
  }
`;

export const StyledImg = styled.img`
  max-width: 150px;
  display: block;
  margin: 0 auto;
`;
